import React from 'react'
import MobWinners from '../../mobileView/winners/MobWinners'
import NavbarMobile from '../../layouts/navabrMobile/NavbarMobile';
import BottomBar from '../../layouts/bottomBar/BottomBar';

const MobileWinners = () => {
  return (
    <div>
                <NavbarMobile />

        <MobWinners />
        <BottomBar/>
    </div>
  )
}

export default MobileWinners;